import React, { Component } from 'react';
import { titleize } from 'underscore.string';
import _ from 'underscore';
import StripeAccountsStore from 'stores/StripeAccountsStore';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { CargomaticDropzone, DROPZONE_VARIANTS } from 'components/v2/Dropzone';
import CargomaticModal from 'components/v2/modal';
import { withTranslation, Translation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import PaymentTerms from 'components/modules/user/shipper/billingv2/PaymentTerms';
import { updateCarrier } from 'utils/CustomersAPIUtils';
import { REGIONS } from 'constants/Regions';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import FileDownload from './FileDownload';
import CustomersActionCreators from '../../../actions/CustomersActionCreators';

import Alert from '../../ui/Alert';
import Badge from '../../v2/Badge';
import CargomaticInput from '../../v2/input';
import { Card, CardHeader, CardContent, CardFooter } from '@cargomatic/ui';
import { DocumentPreviewConfirmationModal } from './modals/DocumentPreviewConfirmationModal';
import CargomaticRadio from '../../v2/forms/Radio';
import LibraryIcon from '../../v2/icons/LibraryIcon';
import SessionStore from '../../../stores/SessionStore';
import CustomerDetailsStore from '../../../stores/CustomerDetailsStore';
import ToastStore, { showToast } from '../../../stores/ToastStore';
import Months from '../../../constants/Months';

import { ACCESSORIAL_PDFS } from '../../../constants/pdf';
import businessTypes from '../../../constants/BusinessTypes';
import stripeVerificationStatus from '../../../constants/stripe';
import Sidebar from './Sidebar';
import Container from '../../v2/container';
import {
  createBankAccount,
  uploadSensitiveDocuments,
} from '../../../utils/CustomersAPIUtils';
import ErrorLabel from '../../v2/forms/ErrorLabel';
import { BILLING_FILE_TYPES } from '../../../config/accepted-file-types';

const hasOwnProperty = Object.prototype.hasOwnProperty;

function renderAccessorialDownloads() {
  const user = SessionStore.getUser();
  const type = user._type.toLowerCase();
  const pdfUrl = ACCESSORIAL_PDFS[type];

  return (
    <FileDownload fileUrl={pdfUrl}>
      <Translation>
        {(t) => <span>{t('VIEW_ACCESSORIAL_DEF_CHARGES')}</span>}
      </Translation>
    </FileDownload>
  );
}

function getInitialState() {
  return {
    stripe_verification: {
      status: '',
    },
    bankAccount: {
      id: null,
      bank_name: '',
      last4: '',
    },
    routing: '',
    account: '',
    first_name: '',
    last_name: '',
    name: '',
    month: '',
    day: '',
    year: '',
    personal_id_number: '',
    line1: '',
    line2: '',
    city: '',
    state: '',
    postal_code: '',
    bank: '',
    ending4Digits: '',
    business_type: 'individual',
    business_name: '',
    business_tax_id: '',
    maxDay: 31,
    maxYear: new Date().getFullYear(),
    errors: {},
    successMessage: '',
    showBankForm: false,
    business_tax_id_provided: false,
    personal_id_number_provided: false,
    is_partner_with_factoring_company: false,
    factoring_company_name: '',
    sensitive_documents: [],
    admin_banking_info_remark: '',
    showPreviewModal: false,
    previewFiles: [],
    currentDocumentType: '',
    showThankingModal: false,
  };
}

const CompanyTooltip = (
  <Tooltip id="tooltip-company-required-details">
    <Translation>
      {(t) => <>{t('BUSINESS_TYPE_COMPANY_TOOLTIP')}</>}
    </Translation>
  </Tooltip>
);

const IndividualTooltip = (
  <Tooltip id="tooltip-individual-required-details">
    <Translation>
      {(t) => <>{t('BUSINESS_TYPE_INDIVIDUAL_TOOLTIP')}</>}
    </Translation>
  </Tooltip>
);

class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = getInitialState();
  }
  componentDidMount() {
    this.getCustomer();
    ToastStore.addChangeListener(this.handleNotifications);
    CustomerDetailsStore.addChangeListener(this.handleReceiveCustomer);
    StripeAccountsStore.addChangeListener(this.handleReceiveStripeInfo);
  }
  componentWillUnmount() {
    ToastStore.removeChangeListener(this.handleNotifications);
    CustomerDetailsStore.removeChangeListener(this.handleReceiveCustomer);
    StripeAccountsStore.removeChangeListener(this.handleReceiveStripeInfo);
  }
  getCustomer() {
    const user = SessionStore.getUser();
    if (user) {
      CustomersActionCreators.getCustomer(user._id, false);
      CustomersActionCreators.getBankAccounts(user._id);
    }
  }
  getValidationState(field) {
    if (hasOwnProperty.call(this.state.errors, field)) {
      return 'error';
    }
    return null;
  }

  getHandleChange = (field) => (value) => {
    this.setState({ [field]: value });
  };

  getRequestData() {
    const { routing, account, bankAccount } = this.state;

    const legal_entity = this.extractLegalEntity();
    const hasExistingBankAccount = bankAccount && bankAccount.id;
    // create bank account
    const data = {
      legal_entity,
      userId: SessionStore.getUser()._id,
      bank_account_id: hasExistingBankAccount ? bankAccount.id : null,
    };

    if (routing && account) {
      data.routing = routing;
      data.account = account;
    }
    return data;
  }

  getPaymentTermsData() {
    const user = SessionStore.getUser();
    const {
      drayage_payment_method,
      drayage_terms,
      shorthaul_payment_method,
      shorthaul_terms,
      stripe_customer_id,
    } = user;
    return {
      drayage_payment_method,
      drayage_terms,
      shorthaul_payment_method,
      shorthaul_terms,
      hasCreditCardOnFile: !!stripe_customer_id,
    };
  }

  // update carrier
  async onSaveCarrier(updates = {}) {
    const user = SessionStore.getUser();
    const payload = { _id: user._id, ...updates };
    await updateCarrier(user._id, payload);
  }

  handleReceiveCustomer = () => {
    const user = CustomerDetailsStore.getDetails();
    if (!user) {
      return;
    }

    let profile = _.pick(
      user,
      'sensitive_documents',
      'is_partner_with_factoring_company',
      'factoring_company_name',
      'all_banking_info_approved',
      'admin_banking_info_remark',
    );
    if (user.stripe_legal_entity) {
      const {
        stripe_legal_entity: {
          first_name,
          last_name,
          dob: { month, day, year },
          personal_id_number_provided,
          business_tax_id_provided,
          business_name,
        },
      } = user;

      profile = {
        ...profile,
        first_name,
        last_name,
        month,
        day,
        year,
        personal_id_number_provided,
        business_tax_id_provided,
        business_name,
      };
    }

    if (user.stripe_verification) {
      const stripe_verification = _.omit(user.stripe_verification, [
        'requirements',
      ]);
      profile = {
        ...profile,
        stripe_verification,
      };
    }

    if (Object.keys(profile).length > 0) {
      this.setState({
        ...profile,
      });
    }
  };

  handleReceiveStripeInfo = () => {
    const accountInfo = StripeAccountsStore.getAccountInfo();

    if (!accountInfo || _.isEmpty(accountInfo)) return;

    const {
      address: { city, state, line1, line2, postal_code },
      business_profile: { name: business_name },
      dob,
      first_name,
      last_name,
      business_type,
      verification: stripe_verification,
    } = accountInfo;

    const bankAccount = (accountInfo.external_accounts || [])[0] || {
      id: null,
      bank_name: '',
      last4: '',
    };

    this.setState({
      bankAccount,
      city,
      state,
      line1,
      line2,
      postal_code,
      business_name,
      day: (dob && dob.day) || '',
      month: (dob && dob.month) || '',
      year: (dob && dob.year) || '',
      first_name,
      last_name,
      business_type,
      stripe_verification,
    });
  };

  handleNotifications = () => {
    const toast = ToastStore.getLatestNotification();
    if (toast && toast.level === 'error') {
      this.setState((prevState) => {
        const errors = {
          ...prevState.errors,
          bankAccount: toast.title,
        };
        return { errors };
      });
    } else if (toast && toast.level === 'success') {
      this.setState({
        successMessage: toast.title,
      });
    }
  };

  handleEINChange = (business_tax_id) => {
    if (business_tax_id) {
      this.setState({
        business_tax_id,
        business_type: businessTypes.COMPANY,
      });
    } else {
      this.setState({
        business_tax_id,
        business_type: businessTypes.INDIVIDUAL,
      });
    }
  };
  handleSubmit = async () => {
    try {
      const errors = this.validate();
      if (Object.keys(errors).length === 0) {
        const data = this.getRequestData();

        // create bank account
        if (this.isPendingOrVerified()) {
          // Prior we were calling update Bank Account.
          // That requires a token and these seems to work just fine?
          await createBankAccount(data);
        } else {
          await createBankAccount(data);
        }
        this.setState({ showThankingModal: true });
        this.getCustomer();
      }
    } catch (e) {
      console.error(e);
    }
  };
  handleDocumentUpload(currentDocumentType) {
    return (files) => {
      this.setState(() => ({
        showPreviewModal: true,
        previewFiles: files,
        currentDocumentType,
      }));
    };
  }

  handleHidePreviewConfirmationModal() {
    this.setState({ showPreviewModal: false });
  }
  handleHideThankingModal() {
    this.setState({ showThankingModal: false });
  }
  async handleDocumentSave() {
    const { t } = this.props;
    try {
      const user = SessionStore.getUser();
      const data = await uploadSensitiveDocuments(
        this.state.previewFiles,
        user._id,
        this.state.currentDocumentType,
      );
      this.setState(
        {
          showPreviewModal: false,
          sensitive_documents: data.sensitive_documents,
        },
        () => {
          this.getCustomer();
        },
      );
      showToast(
        t('DOCUMENT_UPLOADED_SUCCESSFULLY'),
        t('DOCUMENT_UPLOADED_SUCCESSFULLY'),
        'success',
      );
    } catch (e) {
      console.error(e);
      this.setState({ showPreviewModal: false });
      showToast(
        t('UPLOAD_DOCUMENT_FAILED'),
        t('DOCUMENT_UPLOAD_FAILED_RETRY'),
        'error',
      );
    }
  }
  getBankAccountVerificationStatus() {
    const {
      sensitive_documents,
      all_banking_info_approved,
      admin_banking_info_remark,
    } = this.state;
    if (
      (typeof all_banking_info_approved === 'undefined' &&
        !sensitive_documents.length) ||
      (!all_banking_info_approved &&
        (!admin_banking_info_remark || !admin_banking_info_remark.length) &&
        !sensitive_documents.length)
    )
      return;
    if (all_banking_info_approved) {
      return {
        bankAccountVerificationStatus: 'Verified',
        bankAccountVerified: true,
        remark: '',
      };
    }
    if (
      (typeof all_banking_info_approved !== 'undefined' ||
        all_banking_info_approved !== null) &&
      all_banking_info_approved === false
    ) {
      return {
        bankAccountVerificationStatus: 'Declined',
        bankAccountVerified: false,
        remark: admin_banking_info_remark,
      };
    }
    const allActiveDocs = (sensitive_documents || []).filter(
      (doc) => doc.active,
    );
    const consolidatedRemark = allActiveDocs
      .filter((doc) => {
        return (
          doc.status === 'Rejected' &&
          doc.rejectReason &&
          doc.rejectReason.length
        );
      })
      .map((doc) => doc.rejectReason)
      .join(', ');
    if (consolidatedRemark.length > 0) {
      return {
        bankAccountVerificationStatus: 'Declined',
        bankAccountVerified: false,
        remark: consolidatedRemark,
      };
    }
    return {
      bankAccountVerificationStatus: 'Internal Review',
      bankAccountVerified: false,
    };
  }
  hasBankAccountEntry() {
    const { id } = this.state.bankAccount;
    return id && id.length > 0;
  }
  hasBankAccount() {
    const { bankAccount, all_banking_info_approved } = this.state;
    const { id } = bankAccount;
    return all_banking_info_approved && id && id.length > 0;
  }
  isPendingOrVerified() {
    return this.isPending() || this.isVerified();
  }
  isPending() {
    const {
      stripe_verification: { status: verificationStatus },
    } = this.state;
    return verificationStatus === stripeVerificationStatus.PENDING;
  }
  isVerified() {
    const {
      stripe_verification: { status: verificationStatus },
    } = this.state;
    return verificationStatus === stripeVerificationStatus.VERIFIED;
  }
  extractLegalEntity() {
    const {
      first_name,
      last_name,
      month,
      day,
      year,
      personal_id_number,
      business_name,
      business_tax_id,
      line1,
      line2,
      city,
      state,
      postal_code,
      is_partner_with_factoring_company,
      factoring_company_name,
    } = this.state;
    let { business_type } = this.state;

    if (business_tax_id && business_tax_id.length) {
      business_type = businessTypes.COMPANY;
    }

    const legalEntity = {
      business_type,
      first_name,
      last_name,
      personal_id_number,
      dob: {
        month,
        day,
        year,
      },
      address: {
        line1,
        line2,
        city,
        state,
        postal_code,
      },
      is_partner_with_factoring_company,
    };

    if (is_partner_with_factoring_company) {
      legalEntity.factoring_company_name = factoring_company_name;
    }

    if (business_type === businessTypes.COMPANY) {
      legalEntity.business_name = business_name;
      legalEntity.business_tax_id = business_tax_id;
    }

    return legalEntity;
  }
  checkIsDocumentUploaded(document_type) {
    const { sensitive_documents } = this.state;
    return (
      (sensitive_documents || []).filter(
        (doc) => doc.active === true && doc.document_type === document_type,
      ).length > 0
    );
  }
  checkIsActiveDocumentRejected(document_type) {
    const { sensitive_documents } = this.state;
    const doc = (sensitive_documents || []).find(
      (doc) => doc.active === true && doc.document_type === document_type,
    );
    if (!doc || (doc && doc.status !== 'Rejected')) return '';
    if (doc && doc.status === 'Rejected') return doc.rejectReason || 'Rejected';
  }
  validate() {
    const errors = {};
    const { t } = this.props;

    const {
      routing,
      account,
      first_name,
      last_name,
      business_tax_id,
      personal_id_number,
      line1,
      city,
      state,
      postal_code,
      business_type,
      month,
      day,
      year,
      business_name,
      personal_id_number_provided,
      business_tax_id_provided,
      is_partner_with_factoring_company,
      factoring_company_name,
    } = this.state;

    if (!this.isPendingOrVerified()) {
      if (!routing) {
        errors.routing = t('ROUTING_NUMBER_REQUIRED');
      }

      if (!account) {
        errors.account = t('ACCOUNT_NUMBER_REQUIRED');
      }

      if (!this.checkIsDocumentUploaded('w9')) {
        errors.w9 = t('W9_DOCUMENT_REQUIRED');
      }

      if (!this.checkIsDocumentUploaded('voided_check')) {
        errors.voided_check = t('VOIDED_CHECK_OR_BANKS_LETTER_REQUIRED');
      }

      if (
        is_partner_with_factoring_company &&
        !this.checkIsDocumentUploaded('notice_of_assignment')
      ) {
        errors.notice_of_assignment = t('ASSIGNMENT_NOTICE_REQUIRED');
      }
    }

    if (!first_name) {
      errors.first_name = t('FIRST_NAME_REQUIRED');
    }

    if (!last_name) {
      errors.last_name = t('LAST_NAME_REQUIRED');
    }

    if (!month) {
      errors.month = t('DOB_MONTH_REQUIRED');
    }

    if (!day) {
      errors.day = t('DOB_DAY_REQUIRED');
    }

    if (!year) {
      errors.year = t('DOB_YEAR_REQUIRED');
    }

    if (!business_type) {
      errors.business_type = t('BUSINESS_TYPE_REQUIRED');
    }

    if (
      is_partner_with_factoring_company &&
      (!factoring_company_name || !factoring_company_name.length)
    ) {
      errors.factoring_company_name = t('FACTORING_COMPANY_NAME_REQUIRED');
    }

    const personalIdNumberRequired =
      business_type === businessTypes.INDIVIDUAL &&
      !personal_id_number_provided;
    const businessTaxIdRequired =
      businessTypes === businessTypes.COMPANY && !business_tax_id_provided;

    const filteredSSN = personal_id_number.trim().replace(/-/g, '');
    const ssnLength = filteredSSN.length;
    if (personalIdNumberRequired && ssnLength !== 9) {
      errors.personal_id_number = t('VALID_SSN_REQUIRED');
    }

    if (business_type === businessTypes.COMPANY) {
      if (!business_name) {
        errors.business_name = t('BUSINESS_NAME_REQUIRED');
      }
      const filteredEIN = business_tax_id.trim().replace(/-/g, '');
      const einLength = filteredEIN.length;
      if (businessTaxIdRequired && einLength !== 9) {
        errors.business_tax_id = t('VALID_EIN_REQUIRED');
      }
    }

    if (this.isPendingOrVerified()) {
      if (!line1) {
        errors.line1 = t('STREET_LINE1_REQUIRED');
      }

      if (!city) {
        errors.city = t('CITY_REQUIRED');
      }

      if (!state) {
        errors.state = t('STATE_REQUIRED');
      }

      if (!postal_code) {
        errors.postal_code = t('POSTAL_CODE_REQUIRED');
      }
    }

    this.setState({
      errors,
      successMessage: '',
    });

    return errors;
  }
  renderSuccessMessage() {
    if (this.state.successMessage) {
      return <Alert type="success">{this.state.successMessage}</Alert>;
    }
    return null;
  }
  renderErrors() {
    const errorKeys = Object.keys(this.state.errors);
    if (errorKeys.length > 0) {
      return (
        <Alert type="error">
          <ul>
            {errorKeys.map((errorKey, i) => (
              <li key={i}>{this.state.errors[errorKey]}</li>
            ))}
          </ul>
        </Alert>
      );
    }
    return null;
  }
  renderBankInfoSummary() {
    const shouldShowBankAccountInfo = this.hasBankAccountEntry();
    const { t } = this.props;

    if (shouldShowBankAccountInfo) {
      return (
        <>
          <div className="mb-4">
            <h4 className="my-0 mb-4">{t('BANK_ACCOUNT_ON_FILE')}</h4>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full">
                  <LibraryIcon />
                </div>
                <p>
                  <span className="block">
                    {this.state.bankAccount.bank_name}
                  </span>
                  <small className="block text-sm italic">
                    {t('ACCOUNT_NUMBER_ENDING_IN', {
                      last4: this.state.bankAccount.last4,
                    })}
                  </small>
                </p>
              </div>
            </div>
          </div>
          <div className="mt-4 actions items-center">
            <a
              href={`mailto:${BANKING_INFO_UPDATE_CONTACT_EMAIL_ID}?&subject=I'd like to modify my banking information`}
              target="_blank"
              rel="noreferrer"
            >
              {t('MODIFY_YOUR_BANKING_INFO')}
            </a>
          </div>
        </>
      );
    }
    return <h4 className="my-0">{t('NO_BANK_ACCOUNT_ON_FILE')}</h4>;
  }
  renderBankingHeader() {
    const verificationDetails = this.getBankAccountVerificationStatus();
    const { t } = this.props;
    if (typeof verificationDetails === 'undefined') return null;
    const { bankAccountVerificationStatus, bankAccountVerified, remark } =
      verificationDetails;
    return (
      <div className="mt-8">
        <h3 className="my-0">{t('BANK_INFORMATION')}</h3>
        {bankAccountVerificationStatus && (
          <>
            <p>{t('BANKING_INFO_SUBMITTED')}</p>
            <div className="flex gap-4">
              <p>{t('STATUS')}:</p>
              <Badge color={bankAccountVerified ? 'brand' : 'red'}>
                {titleize(t(sluggify(bankAccountVerificationStatus)))}
              </Badge>
              {remark && (
                <p className="text-red-500 text-xs italic">{remark}</p>
              )}
            </div>
          </>
        )}
      </div>
    );
  }
  renderDocumentUpload(document_type) {
    const { t } = this.props;
    const isAlreadyUploaded = this.checkIsDocumentUploaded(document_type);
    const isActiveDocumentRejected =
      this.checkIsActiveDocumentRejected(document_type);
    const defaultUploadButtonClassNames =
      'w-full h-24 mt-4 p-2.5 border-gray-300 border-dashed border-2 rounded text-gray-400';
    const erroredUploadButtonClassNames =
      'w-full h-24 mt-4 p-2.5 border-red-500 border-dashed border-2 rounded text-red-500';
    let spanClassnames = '';
    if (isAlreadyUploaded && isActiveDocumentRejected.length > 0) {
      spanClassnames = 'text-red-500';
    } else if (isAlreadyUploaded && isActiveDocumentRejected.length === 0) {
      spanClassnames = 'text-teal-600';
    } else {
      spanClassnames = '';
    }
    const { errors, is_partner_with_factoring_company } = this.state;
    let displayText = '';
    switch (document_type) {
      case 'w9':
        displayText = 'UPLOAD_W9';
        break;
      case 'voided_check':
        displayText = 'UPLOAD_VOIDED_CHECK_OR_BANKS_LETTER';
        break;
      default:
        displayText = 'UPLOAD_NOTICE_OF_ASSIGNMENT_TEXT';
        break;
    }
    if (isAlreadyUploaded) displayText = 're '.concat(displayText);
    if (
      !is_partner_with_factoring_company &&
      document_type === 'notice_of_assignment'
    )
      return null;
    return (
      <div>
        <CargomaticDropzone
          variant={DROPZONE_VARIANTS.BORDERED}
          className={
            errors[document_type] && errors[document_type].length > 0
              ? erroredUploadButtonClassNames
              : defaultUploadButtonClassNames
          }
          onDrop={this.handleDocumentUpload(document_type)}
          multiple
          accept={BILLING_FILE_TYPES[document_type]}
        >
          <div className={spanClassnames}>
            {t('CLICK_OR_DRAG_TO_ACTION', {
              displayText: t(sluggify(displayText)),
            })}
          </div>
        </CargomaticDropzone>
        <ErrorLabel className="mt-1">{errors[document_type]}</ErrorLabel>
        {isActiveDocumentRejected.length > 0 && (
          <ErrorLabel className="mt-1">
            {`${t('REJECTED')} : ${isActiveDocumentRejected}`}
          </ErrorLabel>
        )}
      </div>
    );
  }
  renderBankInfo() {
    const { errors, account, routing } = this.state;
    const hasBankAccountInfo = this.hasBankAccount();
    const shouldShowBankAccountInfo = this.hasBankAccountEntry();

    if (hasBankAccountInfo && !this.state.showBankForm) {
      return null;
    }
    return (
      <div>
        {!hasBankAccountInfo && (
          <>
            <legend className="flex items-center border-b border-gray-200 border-solid space-x-2">
              <span className="block my-0">{this.props.t('ACCOUNT_INFO')}</span>
            </legend>
            {!shouldShowBankAccountInfo && (
              <div className="grid sm:grid-cols-2 sm:gap-x-4 gap-y-4">
                <CargomaticInput
                  label={`${this.props.t('ACCOUNT_NUMBER')}*`}
                  value={account}
                  placeholder={this.props.t('ACCOUNT_NUMBER')}
                  onChange={this.getHandleChange('account')}
                  error={{ message: errors.account }}
                />
                <CargomaticInput
                  label={`${this.props.t('ROUTING_NUMBER')}*`}
                  value={routing}
                  placeholder={this.props.t('ROUTING_NUMBER')}
                  onChange={this.getHandleChange('routing')}
                  error={{ message: errors.routing }}
                />
              </div>
            )}
            <div className="mt-4">
              {this.renderDocumentUpload('w9')}
              {this.renderDocumentUpload('voided_check')}
              {this.renderDocumentUpload('notice_of_assignment')}
            </div>
          </>
        )}
      </div>
    );
  }
  renderThankingModalBody() {
    const { t } = this.props;
    return (
      <>
        <p className="font-bold">{`${t('BANK_INFO_SUMBIT_GREETINGS')}.`}</p>
        <p>{t('CARGOMATIC_TEAM_REVIEW_MSG')}</p>
      </>
    );
  }
  renderThankingModalFooter() {
    const { t } = this.props;
    return (
      <div className="flex justify-end">
        <button
          onClick={() => this.handleHideThankingModal()}
          className="button button-green"
        >
          {t('CLOSE')}
        </button>
      </div>
    );
  }
  renderCompanyOwner() {
    const {
      stripe_verification: { status: verificationStatus },
    } = this.state;
    const verified = this.isVerified();

    const { first_name, last_name, month, day, year, errors } = this.state;

    const hasBankAccountInfo = this.hasBankAccountEntry();
    if (hasBankAccountInfo) {
      return null;
    }
    const { t } = this.props;

    return (
      <div>
        <legend className="flex items-center border-b border-gray-200 border-solid space-x-2">
          <span className="block my-0">{t('COMPANY_OWNER')}</span>
          {verificationStatus && (
            <Badge color={verified ? 'brand' : 'red'}>
              {titleize(verificationStatus)}
            </Badge>
          )}
        </legend>
        <div className="grid grid-cols-6 gap-4">
          <div className="col-span-full sm:col-span-3">
            <CargomaticInput
              label={`${t('FIRST_NAME')}*`}
              placeholder={t('FIRST_NAME')}
              value={first_name}
              onChange={this.getHandleChange('first_name')}
              error={{ message: errors.first_name }}
            />
          </div>
          <div className="col-span-full sm:col-span-3">
            <CargomaticInput
              label={`${t('LAST_NAME')}*`}
              placeholder={t('LAST_NAME')}
              value={last_name}
              onChange={this.getHandleChange('last_name')}
              error={{ message: errors.last_name }}
            />
          </div>
          <div className="col-span-2">
            <CargomaticInput
              type="select"
              label={`${this.props.t('BIRTH_MONTH')}*`}
              placeholder="Month"
              value={month}
              onChange={this.getHandleChange('month')}
              error={{ message: errors.month }}
              valueKey="value"
              textKey="text"
              items={Months}
            />
          </div>
          <div className="col-span-2">
            <CargomaticInput
              label={`${this.props.t('DAY', { count: 1 })}*`}
              type="number"
              min={1}
              max={31}
              step={1}
              placeholder="Day"
              value={day}
              onChange={this.getHandleChange('day')}
              error={{ message: errors.day }}
            />
          </div>
          <div className="col-span-2">
            <CargomaticInput
              label={`${this.props.t('YEAR', { count: 1 })}*`}
              type="number"
              step={1}
              placeholder="Year"
              value={year}
              onChange={this.getHandleChange('year')}
              error={{ message: errors.year }}
            />
          </div>
        </div>
      </div>
    );
  }
  renderCompanyInfo() {
    const {
      errors,
      business_type,
      business_tax_id,
      business_name,
      personal_id_number,
      is_partner_with_factoring_company,
      factoring_company_name,
    } = this.state;
    const { t } = this.props;
    return (
      <div>
        <legend className="">{t('COMPANY_INFO')}</legend>
        <div
          data-control-id="business_type"
          data-validation-state={this.getValidationState('business_type')}
        >
          <label className="mb-1 form-label">{`${t('BUSINESS_TYPE')}*`}</label>
          <div className="space-y-1">
            <OverlayTrigger placement="top" overlay={CompanyTooltip}>
              <div className="userDetailValue">
                <CargomaticRadio
                  id={businessTypes.COMPANY}
                  name="business_type"
                  value={businessTypes.COMPANY}
                  checked={business_type === businessTypes.COMPANY}
                  onChange={this.getHandleChange('business_type')}
                >
                  {this.props.t('BUSINESS_TYPE_COMPANY')}
                </CargomaticRadio>
              </div>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={IndividualTooltip}>
              <div className="userDetailValue">
                <CargomaticRadio
                  id={businessTypes.INDIVIDUAL}
                  name="business_type"
                  value={businessTypes.INDIVIDUAL}
                  checked={business_type === businessTypes.INDIVIDUAL}
                  onChange={this.getHandleChange('business_type')}
                >
                  {t('BUSINESS_TYPE_INDIVIDUAL')}
                </CargomaticRadio>
              </div>
            </OverlayTrigger>
          </div>
        </div>
        {business_type === businessTypes.COMPANY && (
          <div className="mt-4 grid sm:grid-cols-2 sm:gap-4">
            <CargomaticInput
              type="password"
              label={t('EIN')}
              value={business_tax_id}
              onChange={this.handleEINChange}
              placeholder={t('EIN')}
              error={{ message: errors.business_tax_id }}
            />
            <CargomaticInput
              type="text"
              label={t('BUSINESS_NAME')}
              value={business_name}
              placeholder={t('BUSINESS_NAME')}
              onChange={this.getHandleChange('business_name')}
              error={{ message: errors.business_name }}
            />
          </div>
        )}
        {business_type === businessTypes.INDIVIDUAL && (
          <div className="mt-4 grid sm:grid-cols-2 sm:gap-4">
            <CargomaticInput
              label={`${t('SSN')}*`}
              type="password"
              placeholder={`${t('SSN')}: XXXXXXXXX`}
              value={personal_id_number}
              onChange={this.getHandleChange('personal_id_number')}
              error={{ message: errors.personal_id_number }}
            />
          </div>
        )}
        <div className="mt-4">
          <CargomaticInput
            id="is_partner_with_factoring_company"
            type="checkbox"
            label={t('PARTNER_WITH_FACTORING_COMPANY')}
            value={is_partner_with_factoring_company}
            checked={is_partner_with_factoring_company}
            onChange={this.getHandleChange('is_partner_with_factoring_company')}
          />
          <CargomaticInput
            type="text"
            value={factoring_company_name}
            placeholder={t('ENTER_FACTORING_COMPANY_NAME')}
            disabled={!is_partner_with_factoring_company}
            onChange={this.getHandleChange('factoring_company_name')}
            error={{ message: errors.factoring_company_name }}
          />
        </div>
      </div>
    );
  }
  renderAddress() {
    if (!this.isPendingOrVerified()) {
      return null;
    }
    const { t } = this.props;
    const { business_type } = this.state;
    const sectionHeading =
      business_type === businessTypes.COMPANY
        ? t('COMPANY_ADDRESS')
        : t('PERSONAL_ADDRESS');
    return (
      <div>
        <legend className="">{sectionHeading}</legend>
        <div className="grid grid-cols-6 gap-4">
          <div
            className="col-span-full"
            data-control-id="line1"
            data-validation-state={this.getValidationState('line1')}
          >
            <CargomaticInput
              placeholder="Street"
              label="Street"
              value={this.state.line1}
              onChange={this.getHandleChange('line1')}
            />
          </div>
          <div
            className="col-span-full"
            data-control-id="line2"
            data-validation-state={this.getValidationState('line2')}
          >
            <CargomaticInput
              placeholder="Street 2"
              label="Street 2"
              value={this.state.line2}
              onChange={this.getHandleChange('line2')}
            />
          </div>
          <div
            className="col-span-2"
            data-control-id="city"
            data-validation-state={this.getValidationState('city')}
          >
            <CargomaticInput
              placeholder="City"
              label="City"
              value={this.state.city}
              onChange={this.getHandleChange('city')}
            />
          </div>
          <div
            className="col-span-2"
            data-control-id="state"
            data-validation-state={this.getValidationState('state')}
          >
            <CargomaticInput
              placeholder="State"
              label="State"
              value={this.state.state}
              onChange={this.getHandleChange('state')}
            />
          </div>
          <div
            className="col-span-2"
            data-control-id="postal_code"
            data-validation-state={this.getValidationState('postal_code')}
          >
            <CargomaticInput
              placeholder="Zipcode"
              label="Zipcode"
              value={this.state.postal_code}
              onChange={this.getHandleChange('postal_code')}
            />
          </div>
        </div>
      </div>
    );
  }
  render() {
    const { t } = this.props;
    const actions = (
      <div className="form-actions">
        <button className="button button-green" onClick={this.handleSubmit}>
          {t('SAVE_BANKING_INFORMATION')}
        </button>
      </div>
    );
    return (
      <>
        <Container>
          <div className="lg:grid lg:grid-cols-12 lg:gap-6 mt-10">
            <div className="lg:col-span-3 space-y-4">
              <Sidebar activePage="billing" />
              <div className="px-4">{renderAccessorialDownloads()}</div>
            </div>
            <div className="lg:col-span-6">
              <AuthorizationWrapper excludedRegions={[REGIONS.AP]}>
                <Card>
                  <CardHeader>{this.renderBankingHeader()}</CardHeader>
                  <CardContent>
                    <div className="space-y-6">
                      {this.renderSuccessMessage()}
                      {this.renderErrors()}
                      {this.renderBankInfoSummary()}
                      {this.renderCompanyOwner()}
                      {this.renderCompanyInfo()}
                      {this.renderAddress()}
                      {this.renderBankInfo()}
                    </div>
                  </CardContent>
                  <CardFooter className="flex justify-end">
                    {actions}
                  </CardFooter>
                </Card>
              </AuthorizationWrapper>
              <AuthorizationWrapper excludedRegions={[REGIONS.US]}>
                <PaymentTerms
                  data={this.getPaymentTermsData()}
                  className="mb-4"
                  onUpdateShipper={this.onSaveCarrier}
                  overwritePaymentTermsSlugs
                />
              </AuthorizationWrapper>
            </div>
          </div>
        </Container>
        <DocumentPreviewConfirmationModal
          open={this.state.showPreviewModal}
          files={this.state.previewFiles}
          onRedo={() =>
            this.setState({ previewFiles: [], showPreviewModal: false })
          }
          onSave={() => this.handleDocumentSave()}
          onClose={() => this.handleHidePreviewConfirmationModal()}
        />
        <CargomaticModal
          show={this.state.showThankingModal}
          title={t('BANKING_INFORMATION')}
          onHide={() => this.handleHideThankingModal()}
          body={this.renderThankingModalBody()}
          footer={this.renderThankingModalFooter()}
        />
      </>
    );
  }
}

export default withTranslation()(Billing);
